import { render, staticRenderFns } from "./SubirDocumentacion.vue?vue&type=template&id=8e84d81e"
import script from "./SubirDocumentacion.vue?vue&type=script&lang=js"
export * from "./SubirDocumentacion.vue?vue&type=script&lang=js"
import style0 from "./SubirDocumentacion.vue?vue&type=style&index=0&id=8e84d81e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports